module.exports = __webpack_public_path__ + "img/dstv-login-2.3228936c.jpg";